import { useMemo} from "react";
import { useGlobalState } from "../globalState/GlobalStateProvider";
import { Chip } from "primereact/chip";
import { currencyFormatter } from "../../utils/formatters";

const TopbarSaldo = () => {
  
  const {state} = useGlobalState();

  const saldo = useMemo(() => {
    return state.user.saldo;
  }, [state]);

  
  const content = (
        <>
            <span className="bg-primary border-circle w-2rem h-2rem flex-consulta align-items-center justify-content-center">R$</span>
            <span style={{color: 'white'}} className="ml-2 font-medium">{currencyFormatter(saldo).replace('R$', '')}</span>
        </>
    );

  return (
    <div>
      <Chip style={{backgroundColor: 'transparent', padding: '0.42rem', border: '1px solid white'}} className="pl-0 pr-3" template={content} />
      
    </div>
  );
};

export default TopbarSaldo;
